import React from 'react';
import { Link } from 'react-router-dom';
import './SFPBenefits.css';

const SFPBenefits: React.FC = () => {
  const benefits = [
    'Clear, Transparent Pricing',
    'Maintain Your Prime Badge',
    'Reliable On-Time Dispatch',
    'Low Cancellation Rates',
    'Amazon Buy Shipping Integration',
    'Competitive UK Shipping Rates'
  ];

  return (
    <section className="sfp-benefits">
      <div className="sfp-benefits-container">
        {/* Header Section */}
        <div className="sfp-benefits-header">
          <div className="sfp-benefits-badge">
            <span className="sfp-benefits-badge-dot"></span>
            Why Choose Us
          </div>
          <h2 className="sfp-benefits-title">
            Why Choose Pick Pack Pro for Seller Fulfilled Prime UK?
          </h2>
          <p className="sfp-benefits-description">
            Our Seller Fulfilled Prime UK services help Amazon sellers maintain Prime eligibility with fast
            fulfilment, reliable delivery, and transparent{' '}
            <Link to="/pricing-fulfilment-services">fulfilment pricing</Link> — plus inventory you can also
            sell via <Link to="/multi-channel-fulfillment-services">multi-channel fulfilment</Link> and{' '}
            <Link to="/shopify-fulfillment-services">Shopify fulfilment</Link> without splitting your warehouse.
          </p>
        </div>

        {/* Benefits List */}
        <div className="sfp-benefits-list">
          {benefits.map((benefit, index) => (
            <div key={index} className="sfp-benefit-item">
              <div className="sfp-benefit-bullet"></div>
              <p className="sfp-benefit-text">{benefit}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SFPBenefits;
